"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stepNoteTypes = exports.instructionHasImage = exports.getInstructionThumbnailImage = exports.getInstructionCoverImage = exports.getImageFromFirstStep = exports.getCustomIconLabel = void 0;
var _mediaUtils = require("../utils/media-utils");
var _find = _interopRequireDefault(require("lodash/find"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _get = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getImageFromFirstStep = exports.getImageFromFirstStep = function getImageFromFirstStep(instruction) {
  if (instruction.steps && instruction.steps.length > 0) {
    var firstStepWithImage = (0, _find["default"])(instruction.steps, function (step) {
      return step.imageUrl;
    });
    return firstStepWithImage ? firstStepWithImage.imageUrl : null;
  }
};
var getInstructionCoverImage = exports.getInstructionCoverImage = function getInstructionCoverImage(instruction) {
  return instruction.imageUrl || getImageFromFirstStep(instruction);
};
var getInstructionThumbnailImage = exports.getInstructionThumbnailImage = function getInstructionThumbnailImage(instruction, returnPlaceholder, options) {
  return (0, _mediaUtils.getThumbnail)(getInstructionCoverImage(instruction), returnPlaceholder, options);
};
var instructionHasImage = exports.instructionHasImage = function instructionHasImage(instruction) {
  return instruction && !!instruction.imageUrl && instruction.imageUrl !== '';
};
var stepNoteTypes = exports.stepNoteTypes = {
  WARNING: 'WARNING',
  TIP: 'TIP',
  FIX: 'FIX',
  CUSTOM: 'CUSTOM'
};
var getCustomIconLabel = exports.getCustomIconLabel = function getCustomIconLabel(labelTranslations, currentLanguage) {
  if (!(0, _isArray["default"])(labelTranslations) && !labelTranslations.length) {
    return '';
  }
  var localeObj = (0, _find["default"])(labelTranslations, {
    locale: currentLanguage
  });
  if (!localeObj) {
    return (0, _get["default"])(labelTranslations, '[0].translation');
  }
  return (0, _get["default"])(localeObj, 'translation', '');
};
//# sourceMappingURL=instruction-utils.js.map